import React, { Component } from 'react';
// temp disable - we need to remove moment at some point
// eslint-disable-next-line no-restricted-imports
import { ArrowForward } from '@sparkpost/matchbox-icons';
import {
  formatInputDate,
  formatInputTime,
  getPrecision as getRawPrecision,
  parseDatetime
} from '@sparkpost/report-builder/helpers/date';
import _ from 'lodash';
import moment from 'moment';
import { Grid, TextField } from 'src/components/matchbox';
import { TranslatableText } from 'src/components/text';
import {
  getMomentPrecisionByDate,
  getRollupPrecision,
  getValidDateRange
} from 'src/helpers/metrics';

import styles from './ManualEntryForm.module.scss';

const DATE_PLACEHOLDER = '1970-01-20';
const TIME_PLACEHOLDER = '12:00am';

export default class ManualEntryForm extends Component {
  DEBOUNCE = 500;

  state = {
    toDate: '',
    toTime: '',
    fromDate: '',
    fromTime: ''
  };

  //default precision should only be set for the datepicker for metrics rollup
  getPrecision = this.props.defaultPrecision ? getRollupPrecision : getRawPrecision.useMomentInput;

  componentDidMount() {
    const { to, from } = this.props;
    this.syncPropsToState({ to, from });
  }

  componentWillReceiveProps(nextProps) {
    this.syncPropsToState(nextProps);
  }

  syncPropsToState({ to, from }) {
    this.setState({
      toDate: formatInputDate.useMomentInput(to),
      toTime: formatInputTime.useMomentInput(to),
      fromDate: formatInputDate.useMomentInput(from),
      fromTime: formatInputTime.useMomentInput(from)
    });
  }

  handleFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
    this.debounceChanges();
  };

  debounceChanges = _.debounce(() => {
    this.validate();
  }, this.DEBOUNCE);

  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.validate(e, true);
    }
  };

  handleBlur = (e) => {
    this.validate(e, true);
  };

  validate = (e, shouldReset) => {
    const from = parseDatetime(this.state.fromDate, this.state.fromTime);
    const to = parseDatetime(this.state.toDate, this.state.toTime);
    // allow for prop-level override of "now" (DI, etc.)
    const { now, roundToPrecision, preventFuture, defaultPrecision } = this.props;
    try {
      const precision = this.getPrecision({ from, to, precision: defaultPrecision });
      const { to: roundedTo, from: roundedFrom } = getValidDateRange({
        from: from.toDate(), // a moment instance yet
        to: to.toDate(), // a moment instance yet
        now,
        roundToPrecision,
        preventFuture,
        precision
      });

      return this.props.selectDates({ to: roundedTo, from: roundedFrom, precision }, () => {
        if (e && e.key === 'Enter') {
          this.props.onEnter(e);
        }
      });
    } catch (e) {
      if (shouldReset) {
        this.syncPropsToState(this.props); // Resets fields if dates are not valid
      }
    }
  };

  render() {
    const { toDate, toTime, fromDate, fromTime } = this.state;
    const { roundToPrecision, selectedPrecision } = this.props;

    let precisionLabel = null;
    let precisionLabelValue;
    let shouldDisableTime;
    const from = parseDatetime(fromDate, fromTime);
    const to = parseDatetime(toDate, toTime);

    if (roundToPrecision) {
      try {
        // allow for prop-level override of "now" (DI, etc.)
        const { now = moment() } = this.props;
        const { from: validatedFrom, to: validatedTo } = getValidDateRange({
          from,
          to,
          now,
          roundToPrecision,
          precision: selectedPrecision
        });

        precisionLabelValue = this.getPrecision({
          from: validatedFrom,
          to: validatedTo,
          precision: selectedPrecision
        });
        shouldDisableTime = selectedPrecision
          ? ['day', 'week', 'month'].includes(selectedPrecision)
          : getMomentPrecisionByDate(validatedFrom, validatedTo) === 'days';
      } catch (e) {
        precisionLabelValue = '';
      }

      precisionLabel = !selectedPrecision && (
        <div className={styles.PrecisionLabel}>
          <TranslatableText>Precision: </TranslatableText>
          {_.startCase(_.words(precisionLabelValue).join(' '))}
        </div>
      );
    }

    return (
      <div onKeyDown={this.handleEnter} className={styles.DateFields}>
        <Grid middle="xs">
          <Grid.Column>
            <TextField
              id="fromDate"
              label="From Date"
              labelHidden
              placeholder={DATE_PLACEHOLDER}
              onChange={this.handleFieldChange}
              onBlur={this.handleBlur}
              value={fromDate}
            />
          </Grid.Column>
          <Grid.Column>
            <TextField
              id="fromTime"
              label="From Time"
              labelHidden
              placeholder={TIME_PLACEHOLDER}
              onChange={this.handleFieldChange}
              onBlur={this.handleBlur}
              value={fromTime}
              disabled={shouldDisableTime}
            />
          </Grid.Column>
          <Grid.Column xs={1}>
            <div className={styles.ArrowWrapper}>
              <ArrowForward />
            </div>
          </Grid.Column>
          <Grid.Column>
            <TextField
              id="toDate"
              label="To Date"
              labelHidden
              placeholder={DATE_PLACEHOLDER}
              onChange={this.handleFieldChange}
              onBlur={this.handleBlur}
              value={toDate}
            />
          </Grid.Column>
          <Grid.Column>
            <TextField
              id="toTime"
              label="To Time"
              labelHidden
              placeholder={TIME_PLACEHOLDER}
              onChange={this.handleFieldChange}
              onBlur={this.handleBlur}
              value={toTime}
              disabled={shouldDisableTime}
            />
          </Grid.Column>
        </Grid>
        {precisionLabel}
      </div>
    );
  }
}
